import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-121">
      <div className="max-w-xl mx-auto" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-123">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-124" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-125" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-5 relative z-10" data-id="element-126" />

          <h3 className="text-2xl sm:text-3xl font-black text-brand-cream uppercase mb-4 relative z-10" data-id="element-127">
            Garanzia "Classe Soddisfatta" — 14 giorni
          </h3>

          <div className="text-gray-300 text-base sm:text-lg font-medium leading-relaxed relative z-10 space-y-2" data-id="element-128">
            <p data-id="element-129">
              Siamo così sicuri che il Metodo Economia Aziendale Pro™ ti farà
              risparmiare ore ogni settimana, che ti offriamo{' '}
              <strong className="text-brand-gold" data-id="element-130">14 giorni</strong> di garanzia
              totale.
            </p>
            <p data-id="element-131">
              Se non hai già recuperato almeno{' '}
              <strong className="text-brand-gold" data-id="element-132">
                5 ore nella prima settimana
              </strong>
              , scrivici e ti restituiamo ogni centesimo.
            </p>
            <p className="text-brand-cream font-bold" data-id="element-133">
              Senza domande. Senza burocrazia.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}